import { connect } from 'react-redux'
import AutocompleteSearch from './component'

const mapStateToProps = ({ userProfileManager }) => ({
  userEmail: userProfileManager.profile.email,
})

export default connect(mapStateToProps)(AutocompleteSearch)
